
import LoleVideoPicture from '~/components/picture/lole-video-picture'
import LoleStaticPageHeader from '~/components/static-page/lole-static-page-header'
import LoleStaticPageSectionTitle from '~/components/static-page/lole-static-page-section-title'
import LoleStaticPageSectionTitleImage from '~/components/static-page/lole-static-page-section-title-image'

import LoleStaticPageInfoCard from '~/components/static-page/lole-static-page-info-card'
import LoleStaticPageInfoCard3 from '~/components/static-page/lole-static-page-info-card-3'
import LoleStaticPageLeadershipCard from '~/components/static-page/lole-static-page-leadership-card'
import LoleStaticPageProfileCard from '~/components/static-page/lole-static-page-profile-card'
import LoleStaticPageCtaBanner from '~/components/static-page/lole-static-page-cta-banner'
import LoleStaticPageImageCollage from '~/components/static-page/lole-static-page-image-collage'
import LoleStaticPageH1 from '~/components/static-page/lole-static-page-h1'
import LoleStaticPageH2 from '~/components/static-page/lole-static-page-h2'
import LoleStaticPageText from '~/components/static-page/lole-static-page-text'
import LoleStaticPageExclusiveDealCard from '~/components/static-page/lole-static-page-exclusive-deal-card'

export default {
  components: {
    LoleVideoPicture,
    LoleStaticPageHeader,
    LoleStaticPageSectionTitle,
    LoleStaticPageSectionTitleImage,
    LoleStaticPageInfoCard,
    LoleStaticPageInfoCard3,

    LoleStaticPageLeadershipCard,
    LoleStaticPageProfileCard,
    LoleStaticPageCtaBanner,
    LoleStaticPageImageCollage,
    LoleStaticPageH1,
    LoleStaticPageH2,
    LoleStaticPageText,
    LoleStaticPageExclusiveDealCard,
  },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
}
